import { message } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useLogoutBehavior } from "./useLogoutBehavior";

export function useForgetPasswordBehavior() {
  const { logout } = useLogoutBehavior(false);
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const isOnlyReset = ["safeWarning", "memberCenter"].includes(
    searchParams.get("from") || "",
  );
  const userName = searchParams.get("userName") || "";

  const [userInfo, setUserInfo] = useState({
    username: "",
    email: "",
  });

  const [step, setStep] = useState(0);

  useEffect(() => {
    if (isOnlyReset) {
      setStep(1);
    }

    if (isOnlyReset && userName) {
      setUserInfo((prev) => {
        return {
          ...prev,
          username: userName,
        };
      });
    }
  }, [isOnlyReset, userName]);

  const goNextStep = (nextStep: number) => {
    setStep(nextStep);
  };

  const onVerifyCodeSuccess = (email: string, username: string) => {
    goNextStep(1);

    setUserInfo((prev) => {
      return {
        ...prev,
        email,
        username,
      };
    });
  };

  const redirectToLoginAfterPasswordChange = async () => {
    message.success("密码修改成功，请使用新密码登录");

    try {
      await logout();
    } catch (error) {
      console.error("Logout failed:", error);
      return;
    }

    navigate("/login", { replace: true });
  };

  return {
    userInfo,
    isOnlyReset,
    step,
    goNextStep,
    onVerifyCodeSuccess,
    redirectToLoginAfterPasswordChange,
  };
}
